import { Button } from '@leroy-merlin-br/backyard-react-ui'
import PropTypes from 'prop-types'

const DeliveryTrackLink = ({ trackingUrl }) => (
  <Button href={trackingUrl} target="_blank">
    Acompanhar entrega
  </Button>
)

DeliveryTrackLink.propTypes = {
  trackingUrl: PropTypes.string.isRequired
}

export default DeliveryTrackLink
